<div class="dialog-container">
  <div class="cb-task-icon-dialog__heading">
    <oph-x-button (click)="onCancel()" />
  </div>
  <div class="picker-container">
    <task-icon-picker [hideXButton]="true" (iconChange)="onIconChange($event)"></task-icon-picker>
  </div>

  <div class="dialog-actions">
    <oph-button
      color="gray"
      appearance="outline"
      [style]="{'border-width': '1px', 'border-radius': '8px', width: '121px', height: '46px'}"
      (buttonClick)="onCancel()"
      >Cancel</oph-button
    >
  </div>
</div>
